
/**
 * Initializes a contractor tags select
 *
 * @param {Element} element
 * @param {Object} settings
 * @return {JQuery<HTMLElement>}
 */
function initContractorTagsSelect(element, settings = {}) {
	const defaultSettings = {
		theme: 'bootstrap4',
		tags: true,
		templateResult: tag => {
			if (!tag.id || !tag.element || !tag.element.dataset.uses) {
				return tag.text;
			}

			return $(`
				<div class="d-flex justify-content-between">
					<div>${tag.text}</div>
					<div
						title="Contractors with this tag"
					>
						${tag.element.dataset.uses}
					</div>
				</div>
			`);
		}
	};

	const finalSettings = {
		...defaultSettings,
		...settings,
	}

	return $(element).select2(finalSettings);
}

export {initContractorTagsSelect}
